import { render, staticRenderFns } from "./EventHistoryDocument.vue?vue&type=template&id=6ee678a6&scoped=true"
import script from "./EventHistoryDocument.vue?vue&type=script&lang=js"
export * from "./EventHistoryDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee678a6",
  null
  
)

export default component.exports